import React from 'react';
import PropTypes from 'prop-types';
import { Steps } from 'barnyard/components';

const classNamePrefix = 'Signup-Stepper';

const Stepper = ({ current, showVendorStep }) => (
  <div className={classNamePrefix}>
    <Steps current={current} labelPlacement='vertical'>
      <Steps.Step title='User Information' />
      <Steps.Step title='Clinic Information' />
      {showVendorStep && <Steps.Step title='Vendor Information' />}
    </Steps>
  </div>
);

Stepper.propTypes = {
  current: PropTypes.number,
  showVendorStep: PropTypes.bool,
};

Stepper.defaultProps = {
  current: 0,
  showVendorStep: true,
};

export default Stepper;
